(function () {
    "use strict";

    angular.module("sempraWebapp").controller("SavingsEditController", SavingsEditController);

    /** @ngInject */
    function SavingsEditController(
        $state,
        $stateParams,
        $translate,
        layoutActions,
        savingsActions,
        pricingActions,
        userActions,
        dialogsService
    ) {
        var vm = this;

        // Route param
        vm.accountId = $stateParams.accountId;

        // Loaded data
        vm.savingsUser = null;
        vm.currentCredit = null;

        // Sale types
        vm.saleTypes = [];
        vm.selectedSaleType = null;
        vm.savingsPackages = [];
        vm.defaultValidityDays = 365;

        // Form data
        vm.customAmount = null;
        vm.customPrice = null;
        vm.validFrom = null;
        vm.validTo = null;
        vm.validityDays = null;
        vm.minDate = new Date();
        vm.currency = 'EUR';

        // State
        vm.isLoading = false;
        vm.isSaving = false;

        // Functions
        vm.onSaleTypeChange = onSaleTypeChange;
        vm.onCustomAmountChange = onCustomAmountChange;
        vm.onValidityDaysChange = onValidityDaysChange;
        vm.onValidToChange = onValidToChange;
        vm.saveSavingsAccount = saveSavingsAccount;
        vm.getTotalAmount = getTotalAmount;
        vm.getNewCredit = getNewCredit;
        vm.getPrice = getPrice;
        vm.goBack = goBack;

        init();

        function init() {
            loadSavingsAccount();
        }

        function loadSavingsAccount() {
            vm.isLoading = true;

            // Load company details for currency and default validity
            userActions.getCompanyDetails().then(
                function(companyData) {
                    if (companyData) {
                        if (companyData.savingsExpirationDays) {
                            vm.defaultValidityDays = companyData.savingsExpirationDays;
                        }
                        if (companyData.region && companyData.region.currencyCode) {
                            vm.currency = companyData.region.currencyCode;
                        }
                    }
                    loadSavingsPackagesAndAccount();
                },
                function() {
                    loadSavingsPackagesAndAccount();
                }
            );
        }

        function loadSavingsPackagesAndAccount() {
            pricingActions.getCompanySavingsPackages().then(
                function(response) {
                    vm.savingsPackages = response || [];
                    buildSaleTypesList();
                    fetchAccount();
                },
                function() {
                    vm.savingsPackages = [];
                    buildSaleTypesList();
                    fetchAccount();
                }
            );
        }

        function buildSaleTypesList() {
            vm.saleTypes = [
                { value: 'REGULAR', label: $translate.instant('SAVINGS_SALE_TYPE_REGULAR'), isPackage: false, package: null }
            ];

            if (vm.savingsPackages && vm.savingsPackages.length > 0) {
                vm.savingsPackages.forEach(function(pkg) {
                    vm.saleTypes.push({
                        value: 'PACKAGE_' + pkg.id,
                        label: pkg.name + ' - ' + pkg.credit.amount.toFixed(2) + ' ' + pkg.credit.code,
                        isPackage: true,
                        package: pkg
                    });
                });
            }

            vm.selectedSaleType = vm.saleTypes[0];
        }

        function fetchAccount() {
            savingsActions.getSavingsAccount(vm.accountId).then(
                function (data) {
                    vm.savingsUser = data;

                    // Store current credit for summary comparison
                    vm.currentCredit = data.balanceAmount;
                    vm.currency = data.balanceCode || vm.currency;

                    // Top-up: start with 0 amount
                    vm.customAmount = 0;
                    vm.customPrice = 0;

                    if (data.createdAt) {
                        vm.validFrom = new Date(data.createdAt);
                    }

                    if (data.expirationDate) {
                        vm.validTo = new Date(data.expirationDate);
                        calculateValidityDays();
                    }

                    vm.isLoading = false;
                },
                function (error) {
                    vm.isLoading = false;
                    console.error('Error loading savings account:', error);
                    dialogsService.showErrorDialog(
                        $translate.instant('ERROR'),
                        $translate.instant('SAVINGS_LOAD_ERROR')
                    );
                    goBack();
                }
            );
        }

        function onSaleTypeChange() {
            if (vm.selectedSaleType.isPackage && vm.selectedSaleType.package) {
                if (vm.selectedSaleType.package.validity) {
                    vm.validityDays = vm.selectedSaleType.package.validity;
                } else {
                    vm.validityDays = vm.defaultValidityDays;
                }
                updateValidTo();
            }
        }

        function onCustomAmountChange() {
            vm.customPrice = vm.customAmount;
        }

        function getTotalAmount() {
            if (vm.selectedSaleType && vm.selectedSaleType.isPackage && vm.selectedSaleType.package) {
                return vm.selectedSaleType.package.credit ? vm.selectedSaleType.package.credit.amount : 0;
            }
            return vm.customAmount || 0;
        }

        function getPrice() {
            if (vm.selectedSaleType && vm.selectedSaleType.isPackage && vm.selectedSaleType.package) {
                return vm.selectedSaleType.package.price ? vm.selectedSaleType.package.price.amount : 0;
            }
            return vm.customPrice || 0;
        }

        function getNewCredit() {
            return (vm.currentCredit || 0) + getTotalAmount();
        }

        function onValidityDaysChange() {
            if (vm.validityDays > 0) {
                updateValidTo();
            }
        }

        function updateValidTo() {
            if (vm.validFrom && vm.validityDays > 0) {
                var newValidTo = new Date(vm.validFrom);
                newValidTo.setDate(newValidTo.getDate() + vm.validityDays);
                vm.validTo = newValidTo;
            } else if (vm.validityDays > 0) {
                var newValidTo = new Date();
                newValidTo.setDate(newValidTo.getDate() + vm.validityDays);
                vm.validTo = newValidTo;
            }
        }

        function onValidToChange() {
            calculateValidityDays();
        }

        function calculateValidityDays() {
            if (vm.validTo) {
                var now = new Date();
                var diffTime = vm.validTo.getTime() - now.getTime();
                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                vm.validityDays = diffDays > 0 ? diffDays : 0;
            }
        }

        function saveSavingsAccount() {
            if (!validateForm()) {
                return;
            }

            vm.isSaving = true;
            layoutActions.showLoader();

            var editData = {
                amount: getTotalAmount(),
                currency: vm.currency,
                validTo: formatDateForApi(vm.validTo),
                validityDays: vm.validityDays
            };

            savingsActions.editSavingsAccount(vm.accountId, editData).then(
                function (response) {
                    vm.isSaving = false;
                    layoutActions.hideLoader();
                    goBack();
                },
                function (error) {
                    vm.isSaving = false;
                    layoutActions.hideLoader();
                    console.error('Error editing savings account:', error);
                    dialogsService.showErrorDialog(
                        $translate.instant('ERROR'),
                        $translate.instant('SAVINGS_EDIT_ERROR')
                    );
                }
            );
        }

        function formatDateForApi(date) {
            if (!date) return null;
            var d = new Date(date);
            var year = d.getFullYear();
            var month = ('0' + (d.getMonth() + 1)).slice(-2);
            var day = ('0' + d.getDate()).slice(-2);
            return year + '-' + month + '-' + day;
        }

        function validateForm() {
            if (!getTotalAmount() || getTotalAmount() <= 0) {
                return false;
            }
            if (!vm.validTo) {
                return false;
            }
            return true;
        }

        function goBack() {
            $state.go('app.savings');
        }
    }
})();
